import * as React from "react";
import { Control, useFieldArray, useWatch } from "react-hook-form";
import {
  Text,
  Grid,
  Title,
  Button,
  ActionIcon,
  Modal,
  Group,
  Divider,
  useMantineTheme,
  Stack,
  Flex,
} from "@mantine/core";

import {
  CCheckbox,
  CMultiSelect,
  CMultiSelectCreatable,
  CRadioGroup,
  CSelect,
  CTextarea,
  CTextInput,
} from "@supportinitiative/react-hook-form-mantine";

import { UseCaseCVMContext } from "./UseCaseCVMContext";

import { columnTypes } from "./UseCaseUtils";
import { IconPlus, IconTrash } from "@tabler/icons-react";
import { getId } from "../utilities";
import DashboardCVM from "./DashboardCVM";
import { UseCaseType } from "@supportinitiative/common";

function DashboardsAndActionsCVM({
  name,
  control,
}: {
  name: `definition`;
  control: Control<UseCaseType>;
}) {
  const { state: useCaseFormState } = React.useContext(UseCaseCVMContext);
  const theme = useMantineTheme();

  const dashboardsArray = useFieldArray({
    control,
    name: `${name}.dashboards`,
    keyName: "key",
  });

  const customActionsArray = useFieldArray({
    control,
    name: `${name}.customActions`,
    keyName: "key",
  });

  return (
    <Stack
      style={{
        marginTop: theme.spacing.xs,
        padding: theme.spacing.xs,
        width: "100%",
        minHeight: "450px",
      }}
    >
      <Stack gap="0">
        <Group mb="xs" align="center" style={{ alignItems: "center" }}>
          <Flex>
            <Title
              m={0}
              order={5}
              style={{
                padding: "0px 5px",
                backgroundColor: "#16A596",
                color: "#fff",
              }}
            >
              Dashboards
            </Title>
          </Flex>
          <ActionIcon
            size="sm"
            variant="white"
            color="gray"
            onClick={() => {
              dashboardsArray.append({
                id: getId(),
                name: "Dashboard",
                genFunction: "",
                displayColumns: [],
              });
            }}
            style={{
              display:
                useCaseFormState.currentAction.toUpperCase() === "VIEW"
                  ? "none"
                  : "",
            }}
            disabled={useCaseFormState.actionOptions.disableAll}
          >
            <IconPlus />
          </ActionIcon>
        </Group>

        {dashboardsArray.fields.length === 0 ? (
          <Grid align="stretch" gutter={"xs"} mb="xs">
            <Grid.Col span={4}>
              <Divider label="No Dashboards" labelPosition="left" />
            </Grid.Col>
          </Grid>
        ) : (
          <Grid align="stretch" gutter={"xs"} mb="xs">
            {dashboardsArray.fields.map((field, index) => {
              return (
                <Grid.Col span={2} key={field.key}>
                  <Flex align="end">
                    <DashboardCVM
                      name={`definition.dashboards.${index}`}
                      control={control}
                    />
                    {!useCaseFormState.actionOptions.disableAll && (
                      <ActionIcon
                        size="sm"
                        variant="white"
                        color="gray"
                        ml="xs"
                        onClick={() => {
                          dashboardsArray.remove(index);
                        }}
                        disabled={useCaseFormState.actionOptions.disableAll}
                      >
                        <IconTrash />
                      </ActionIcon>
                    )}
                  </Flex>
                </Grid.Col>
              );
            })}
          </Grid>
        )}
      </Stack>

      <Stack gap="0">
        <Group mb="xs" align="center" style={{ alignItems: "center" }}>
          <Flex>
            <Title
              m={0}
              order={5}
              style={{
                padding: "0px 5px",
                backgroundColor: "#16A596",
                color: "#fff",
              }}
            >
              Actions
            </Title>
          </Flex>
          <ActionIcon
            size="sm"
            variant="white"
            color="gray"
            onClick={() => {
              customActionsArray.append({
                name: "",
                id: getId(),
              });
            }}
            style={{
              display:
                useCaseFormState.currentAction.toUpperCase() === "VIEW"
                  ? "none"
                  : "",
            }}
            disabled={useCaseFormState.actionOptions.disableAll}
          >
            <IconPlus />
          </ActionIcon>
        </Group>

        {customActionsArray.fields.length === 0 ? (
          <Grid align="stretch" gutter={"xs"} mb="xs">
            <Grid.Col span={4}>
              <Divider label="No Actions" labelPosition="left" />
            </Grid.Col>
          </Grid>
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "10px",
            }}
          >
            <Grid align="stretch" gutter={"xs"} mb="xs">
              {customActionsArray.fields.map((field, index) => {
                return (
                  <React.Fragment key={field.key}>
                    <Grid.Col span={2} key={field.key}>
                      <Flex align="end">
                        {/* <DashboardCVM
                          name={`definition.dashboards.${index}`}
                          control={control}
                        /> */}
                        {!useCaseFormState.actionOptions.disableAll && (
                          <ActionIcon
                            size="sm"
                            variant="white"
                            color="gray"
                            ml="xs"
                            onClick={() => {
                              customActionsArray.remove(index);
                            }}
                            disabled={useCaseFormState.actionOptions.disableAll}
                          >
                            <IconTrash />
                          </ActionIcon>
                        )}
                      </Flex>
                    </Grid.Col>
                  </React.Fragment>
                );
              })}
            </Grid>
          </div>
        )}
      </Stack>
    </Stack>
  );
}

export default DashboardsAndActionsCVM;
